import "../src/styles/tw-global.css";
import "../src/styles/app.scss";

function MyApp({ Component, pageProps }) {
  return <Component {...pageProps} />;
}

export default MyApp;
